import React from 'react';
import Table from '../../../../../components/_table/Table/Table';
import Button from '../../../../../components/Button';
import Panel from '../../../../../components/outline/Panel';
import { columns } from './columns';
import './RecommendProductDetailItemList.scss';

const RecommendProductDetailItemList = (props) => {
  const { recommendProductItemList, getProductSubCategoryList, totalCnt, pagination, getList, getExcelDownload } =
    props;

  return (
    <Panel className="recommend-product-detail-item-list">
      <div className="panel-header">
        <div className="title">추천 상품 아이템 리스트</div>

        <Button isRadius color="primary" text="엑셀 다운로드" onClick={() => getExcelDownload()} />
      </div>

      <div className="panel-body">
        <Table
          columns={() =>
            columns({
              getProductSubCategoryList,
            })
          }
          rowKey={(record) => record.id}
          list={recommendProductItemList}
          size="small"
          scroll={{ x: true }}
          bordered={true}
          getList={getList}
          pagination={{
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize,
            totalCnt,
          }}
        />
      </div>
    </Panel>
  );
};

export default RecommendProductDetailItemList;
